import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { JwtService } from './jwt.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class ClientRegisterService {
  private baseUrl = `${environment.API_URL}/auth/auth/register`;

  constructor(private http: HttpClient, private jwtService: JwtService) {}

  register(props: Object): Observable<any> {
    return this.http.post<any>(this.baseUrl, props, httpOptions).pipe(
      map((resp) => {
        this.jwtService.saveToken(resp.token);
        return resp;
      })
    );
  }
}
